import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {
  faHome,
  faQuestion,
  faGift,
  faCar,
  faDollarSign,
  faEnvelope,
  faSignOut,
  faSignIn,
  faChevronUp,
  faPlus,
  faUserPlus
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCalendarAlt,
  faCircle
} from '@fortawesome/pro-regular-svg-icons';
import { faScroll } from '@fortawesome/free-solid-svg-icons';
import { Link, withRouter } from 'react-router-dom';
import Pricing from '../../images/Icons/Pricing.svg';
import Divider from '../../artzu-ui/src/Divider';
import './sideBarContent.css';
import importantRules from '../../images/driverpolicy-images/Important Rules.png';
import { isLoggedIn } from '../../utils/localStorage';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  isPrelimStatus = () =>
    [
      'subscribed',
      'lead',
      'signed_up',
      'account_pending',
      'bgc_pending',
      'ptc_pending',
      'fleet_pending'
    ].includes(this.props.status);

  getItems = () => {
    const {
      signedIn,
      status,
      location: { pathname }
    } = this.props;
    if (signedIn && status) {
      return [
        {
          name: 'Dashboard',
          href: '/dashboard',
          icon: faHome,
          active: true
        },
        {
          name: 'Book',
          href: '/book',
          icon: faCalendarAlt,
          active: status === 'operating'
        },
        {
          name: 'Pricing',
          href: '/pricing',
          icon: Pricing,
          active: status === 'operating'
        },
        // {
        //   name: 'Important Rules',
        //   href: '/rules',
        //   icon: faScroll,
        //   active: status === 'operating'
        // },

        { divider: true },
        // { name: 'Announcements', href: '/Announcements', icon: faBell, active: status === 'operating' },
        {
          name: 'Promotions',
          href: '/promotions',
          icon: faGift,
          active: status !== 'weekly_lease'
        },
        { divider: true },
        {
          name: 'My Bookings',
          href: '/mybookings',
          icon: faCar,
          active: !this.isPrelimStatus() && status !== 'weekly_lease'
        },
        {
          name: 'My Earnings',
          href: '/myearnings',
          icon: faDollarSign,
          active: !this.isPrelimStatus()
        },
        { divider: true },
        {
          name: 'Help',
          href: '/driverfaq',
          icon: faQuestion,
          active: status === 'operating'
        },
        {
          name: 'Contact Us',
          href: '/contact',
          icon: faEnvelope,
          active: true
        },
        { name: 'Logout', href: '/logout', icon: faSignOut, active: true }
      ];
    }
    // if (routes.includes(pathname)) {
    //   return [
    //     { name: 'Go', href: '/go', icon: faCircle, active: true },
    //     { name: 'FAQ', href: '/nyc/faq', icon: faQuestion, active: true },
    //     {
    //       name: 'Promotions',
    //       href: '/promotions',
    //       icon: faGift,
    //       active: true
    //     },
    //     { divider: true },
    //     { name: 'Log In', href: '/login', icon: faSignIn, active: true },
    //     {
    //       name: 'Sign Up',
    //       href: '/signup',
    //       icon: faUserPlus,
    //       active: true
    //     },
    //     { divider: true },
    //     {
    //       name: 'Contact Us',
    //       href: '/contact',
    //       icon: faEnvelope,
    //       active: true
    //     }
    //   ];
    // }
    const prefix = pathname.includes('tor')
      ? '/tor'
      : pathname.includes('nyc')
      ? '/nyc'
      : pathname.includes('sf')
      ? '/sf'
      : pathname.includes('la')
      ? '/la'
      : pathname.includes('ott')
      ? '/ott'
      : null;
    
      const toggleLog = () => {
        if (isLoggedIn()){
          return { name: 'Log Out', href: '/signout', active: true }
        }
        else {
          return { name: 'Log In', href: '/login', active: true }
        }
      }

    return [
      { name: 'EV', href: `${prefix}/ev`, active: true },
      { name: 'FAQ', href: `${prefix}/faq`, active: true },
      {
        name: 'Promotions',
        href: '/promotions',
        active: true
      },
      { divider: true },
      { name: 'Profile', href: '/userpage', active: isLoggedIn()},
      toggleLog(),
      { name: 'Sign Up', href: '/signup', active: true },
      { divider: true },
      {
        name: 'Careers',
        href: `${prefix}/careers`,
        active: true
      },
      // {
      //   name: 'Investors',
      //   href: '/investors',
      //   active: true
      // },
      {
        name: 'Contact Us',
        href: `${prefix}/contact`,
        active: true
      },
      { divider: true },
      {
        name: 'Terms & Conditions',
        href: `${prefix}/terms`,
        active: true
      },
      {
        name: 'Privacy',
        href: `${prefix}/privacy`,
        active: true
      }
    ];
  };

  render() {
    const { history, location, closeMenu = () => {} } = this.props;
    return (
      <div className="sidebar-index">
        {this.getItems().map((item, index) =>
          item.divider ? (
            <Divider key={index} />
          ) : (
            <div
              key={index}
              className={`sidebar-item ${
                item.active ? '' : 'sidebar-item--inactive'
              }`}
              onClick={() => {
                if (item.active) {
                  closeMenu();
                  history.push(item.href);
                }
              }}>
              {item.name === 'Pricing' ? (
                <img
                  src={Pricing}
                  alt="pricing"
                  className="sidebar-icon"
                />
              ) : (
                <FontAwesomeIcon
                  className="sidebar-icon"
                  icon={item.icon}
                />
              )}
              <h5
                className={`sidebar-label ${
                  item.href === location.pathname
                    ? 'sidebar-label--selected'
                    : ''
                }`}>
                {item.name}
              </h5>
            </div>
          )
        )}
        {/* <div className="sidebar-footer">
          <Link onClick={() => closeMenu()} to="/terms">
            Terms & Conditions
          </Link>
          <Link onClick={() => closeMenu()} to="/privacy">
            Privacy
          </Link>
        </div> */}
      </div>
    );
  }
}

export default withRouter(SideBar);



// WEBPACK FOOTER //
// ./src/components/SideBar/SideBarContent.js